import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Renderer2, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { paths } from '@platform/paths';
import { ModalContainerComponent } from '@shared-lib/components/modal-container/modal-container.component';
import { ButtonDirective } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'cp-cookie-consent-dialog',
  imports: [ButtonDirective, ModalContainerComponent, RouterLink],
  templateUrl: './cookie-consent-dialog.component.html',
  styleUrl: './cookie-consent-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('growShrink', [
      state(
        'hidden',
        style({
          height: '0',
          opacity: 0,
          overflow: 'hidden',
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: 0,
          marginBottom: 0,
        }),
      ),
      state(
        'visible',
        style({
          height: '*',
          opacity: 1,
        }),
      ),
      transition('hidden <=> visible', [animate('0.4s ease-in-out')]),
    ]),
  ],
})
export class CookieConsentDialogComponent implements AfterViewInit {
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly dynamicDialogRef = inject(DynamicDialogRef);
  private readonly elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);

  protected readonly paths = paths;

  protected isDialogPositionUp = false;
  protected showDetails = false;

  ngAfterViewInit(): void {
    requestAnimationFrame(() => {
      this.isDialogPositionUp = true;
      this.changeDetectorRef.markForCheck();

      // Make it always on top of other dialogs
      const dialogMaskElement = this.elementRef.nativeElement.closest('.p-dialog-mask');
      this.renderer.setStyle(dialogMaskElement, 'z-index', 10000);
    });
  }

  agree(): void {
    this.dynamicDialogRef.close(true);
  }

  disagree(): void {
    this.dynamicDialogRef.close(false);
  }

  setShowDetails(value: boolean): void {
    this.showDetails = value;
  }
}
